import { render } from "./BaseMapa.vue?vue&type=template&id=f4fa4dac&scoped=true"
import script from "./BaseMapa.vue?vue&type=script&lang=js"
export * from "./BaseMapa.vue?vue&type=script&lang=js"

import "./BaseMapa.vue?vue&type=style&index=0&id=f4fa4dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fa4dac"]])

export default __exports__